import React from 'react';
import { useHistory } from 'react-router-dom';
import { H4, NamedLink, PrimaryButtonInline } from '../../components';

import { createResourceLocatorString } from '../../util/routes';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { useRouteConfiguration } from '../../context/routeConfigurationContext';

import css from './SectionHeroCustom.module.css';

import card1 from '../../assets/hero/1.png';
import card2 from '../../assets/hero/2.png';
import card3 from '../../assets/hero/3.png';
import card4 from '../../assets/hero/4.png';
import heroBanner from '../../assets/hero/hero-banner.png';
import { ReactComponent as ArrowRightSVG } from '../../assets/svg/arrow-right.svg';
import { useSelector } from 'react-redux';
import { useNativeLang } from '../../hooks/useNativeLang';

const cards = [
  {
    image: card1,
    name: { en: 'Construction', ar: 'بناء' },
    searchKeyword: 'construction',
  },
  {
    image: card2,
    name: { en: 'Business Service', ar: 'خدمة الأعمال' },
    searchKeyword: 'businessService',
  },
  {
    image: card3,
    name: { en: 'Home Decor', ar: 'ديكور المنزل' },
    searchKeyword: 'homeDecor',
  },
  {
    image: card4,
    name: { en: 'Repair and Services', ar: 'الإصلاح والخدمات' },
    searchKeyword: 'repairAndServices',
  },
];

const SectionHeroCustom = props => {
  const history = useHistory();
  const routeConfiguration = useRouteConfiguration();
  const { userNativeLang } = useNativeLang();

  return (
    <article className={css.root}>
      <section
        className={css.sliderContainer}
        style={{
          backgroundImage: `url(${heroBanner})`,
        }}
        onClick={() => {
          history.push(createResourceLocatorString('SearchPage', routeConfiguration, {}, {}));
        }}
      >
        <div className={css.sliderContent}>
          <H4>
            <FormattedMessage id="SectionHeroCustom.bannerHeading" />
          </H4>
          <div>
            <PrimaryButtonInline className={css.getBestDealsButton}>
              <FormattedMessage id="LandingPage.getBestDeals" />
            </PrimaryButtonInline>
          </div>
        </div>
      </section>

      <section className={css.cardsContainer}>
        {/* {Array.from({ length: 4 }, (_, index) => index + 1).map(e => ( */}
        {cards.map(card => (
          <div
            key={card.searchKeyword}
            className={css.cardContainer}
            style={{
              backgroundImage: `url(${card.image})`,
            }}
          >
            <div
              className={css.cardContent}
              onClick={() => {
                // const params = {};
                const params = { pub_category: card.searchKeyword };
                history.push(
                  createResourceLocatorString('SearchPage', routeConfiguration, {}, params)
                );
              }}
            >
              <H4>{card.name[userNativeLang] ?? card.name.en}</H4>
              <div>
                {/* <NamedLink name="SearchPage"> */}
                <FormattedMessage id="LandingPage.explore" />
                <ArrowRightSVG />
                {/* </NamedLink> */}
              </div>
            </div>
          </div>
        ))}
      </section>
    </article>
  );
};

export default SectionHeroCustom;
